export const exportTaskStatusOptions = [
  { label: '全部', value: '' },
  { label: '进行中', value: 1 },
  { label: '成功', value: 2 },
  { label: '失败', value: 3 },
];

export const exportTaskStatusTagMap: Record<string, { color: string; text: string }> = {
  0: { color: 'default', text: '待处理' },
  1: { color: 'processing', text: '进行中' },
  2: { color: 'success', text: '成功' },
  3: { color: 'error', text: '失败' },
};
